import React from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import ColorPicker from './ColorPicker';
import Ranges from '../../../system/ranges';
import {Action} from '../../../system/buttons';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';
import css from './StalkerWidgetEdit.module.css';

const HexToName = {
  '#7E733F': 'green',
  '#F43925': 'red',
  '#1C1C25': 'black',
};
// reverse hex to name
const NameToHex = {
  green: '#7E733F',
  red: '#F43925',
  black: '#1C1C25',
};

export const StalkerWidgetEdit = (props) => {
  const updateConfiguration = (configPart: any) => {
    const newConfiguration = {...props.configuration, ...configPart};
    props.onUpdate(newConfiguration);
  };

  const handleOnSave = () => {
    props.onSave(props.configuration);
  };

  return (
    <div>
      <PremiumWrapperOverlay
        bi={{
          from: 'widget_edit_premium_update',
          id: props.id,
        }}
        disabled={!props.premiumUpdate}
      >
        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Device Color
          </Form.Label>

          <ColorSelect
            onSelect={(color) =>
              updateConfiguration({baseColor: HexToName[color]})
            }
            colors={['#7E733F', '#F43925', '#1C1C25']}
            value={NameToHex[props.configuration.baseColor]}
          />
        </Form.Group>
        <Form.Group>
          <Ranges
            ranges={props.configuration.ranges}
            onRangesChange={(ranges) => updateConfiguration({ranges})}
            header={
              <Col md={3}>
                <Form inline>
                  <Col>Color</Col>
                </Form>
              </Col>
            }
            rangeConfiguration={(range, onRangeChange) => (
              <Col md={3} key={range.from}>
                <Row>
                  <Col>
                    <Form inline>
                      <ColorPicker
                        color={range.pulseColor}
                        onChangeComplete={(pulseColor) =>
                          onRangeChange({...range, pulseColor})
                        }
                      />
                    </Form>
                  </Col>
                </Row>
              </Col>
            )}
          />
        </Form.Group>
        <Action onClick={handleOnSave}>Save settings</Action>
      </PremiumWrapperOverlay>
    </div>
  );
};

const ColorSelect = ({
  colors,
  value,
  onSelect,
}: {
  colors: string[];
  value: string;
  onSelect: (string) => void;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem',
        alignItems: 'center',
      }}
    >
      {colors.map((color) => (
        <div
          className={css.colorSelectOption}
          onClick={() => onSelect(color)}
          key={color}
          style={{
            width: '1.5rem',
            height: '1.5rem',
            borderRadius: '0.5rem',
            backgroundColor: color,
            border: value === color ? '2px solid black' : 'none',
          }}
        />
      ))}
    </div>
  );
};
